







import {truncate} from '@/shared/filters/utils-filter';
import {defineComponent} from "@vue/composition-api";

export default defineComponent({
    name: 'ActiveFilter',
    props: {
        filter: {type: String}
    },
    methods: {
        truncate
    }
})
